import { Action, createReducer, on } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { InstalledView, NotificationView } from 'src/app/model/device';

import * as DeviceListActions from './device-list.actions';

export interface State {
    loading: boolean;
    installedViews: InstalledView[];
    notificationView: NotificationView[];
    paging?: ItemsPagination;
}

const initialState: State = {
    loading: false,
    installedViews: [],
    notificationView: [],
};

const deviceListReducer = createReducer(
    initialState,
    on(DeviceListActions.getInstalledViews, (state) => ({ ...state, loading: true })),
    on(DeviceListActions.getInstalledViewsSuccess, (state, payload) => ({
        ...state,
        installedViews: payload.installedViews,
        paging: payload.paging,
        loading: false
    })),

    on(DeviceListActions.getNotificationView, (state) => ({ ...state, loading: true })),
    on(DeviceListActions.getNotificationViewSuccess, (state, payload) => ({
        ...state,
        notificationView: payload.notificationView,
        paging: payload.paging,
        loading: false
    })),
    on(DeviceListActions.getNotificationViewFailed, (state) => ({
        ...state,
        loading: false
    })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceListReducer(state, action);

